import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { FC, ReactNode } from 'react';

type HeightRevealProps = {
  children: ReactNode;
  className?: string;
  isShown: boolean;
};

/**
 * Mounts its content by growing it from zero height as it fades in, and collapses it the same way
 * before unmounting it, so whatever sits below slides instead of jumping. Content already shown on
 * the first render appears as is.
 */
export const HeightReveal: FC<HeightRevealProps> = ({ children, className, isShown }) => {
  const isReducedMotion = useReducedMotion();

  return (
    <AnimatePresence initial={false}>
      {isShown && (
        <motion.div
          animate={{ height: 'auto', opacity: 1 }}
          className={className}
          exit={{ height: 0, opacity: 0 }}
          initial={{ height: 0, opacity: 0 }}
          style={{ overflow: 'hidden' }}
          transition={{ duration: isReducedMotion ? 0 : 0.2, ease: 'easeInOut' }}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
